import {
  DialogTitle as RMWCDialogTitle,
  type DialogTitleProps,
} from '@rmwc/dialog';
import type {PropsWithChildren} from 'react';

const DialogTitle = ({
  className,
  ...props
}: Partial<DialogTitleProps & PropsWithChildren> & {
  className?: string;
}): React.JSX.Element => {
  return (
    <RMWCDialogTitle
      className={className}
      {...props}
    />
  );
};

export {DialogTitle};
